import { Component, OnInit, ViewChild, ViewEncapsulation, ChangeDetectorRef, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { EventInput } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGrigPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { HanhChanhService } from '../hanh-chanh-service/hanh-chanh.service';
import { QueryParamsModel, LayoutUtilsService, MessageType } from 'app/core/_base/crud';
import { DatPhongHopModel } from '../dat-phong-hop-model/dat-phong-hop.model';
import { MatDialog } from '@angular/material';
import { DatPhongHopEditComponent } from '../dat-phong-hop-edit/dat-phong-hop-edit.component';
import { BehaviorSubject } from 'rxjs';
import { PhongHopModel } from '../../phong-hop/phong-hop-model/phong-hop.model';
import { PhongHopEditComponent } from '../../phong-hop/phong-hop-edit/phong-hop-edit.component';
@Component({
  selector: 'kt-dat-phong-hop',
  templateUrl: './dat-phong-hop.component.html',
  styleUrls: ['./dat-phong-hop.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatPhongHopComponent implements OnInit {
  @ViewChild('calendar', { static: true }) calendar: FullCalendarComponent;
  @Input() data: BehaviorSubject<any>;//Dữ liệu truyền vào(nếu có)
  @Output() BookingValue = new EventEmitter();
  calendarPlugins = [dayGridPlugin, timeGrigPlugin, interactionPlugin];
  _title: string = "";
  option: any;
  weekText: string = "";
  lstEvent: any[];
  selectedRoom: any = {};
  selectedStatus: string = "-1";
  lstPhong: any[] = [];
  _data: any = {};
  textTime:string="";
  calendarEvents: EventInput[] = [
    { title: 'Event Now', start: new Date() }
  ];
  DUYET = 153;
  LIST_ROLES_USER: [] = [];
  SHOW_BUTTON_APPROVE = new BehaviorSubject<boolean>(false);
  SHOW_BUTTON_BOOKING: boolean = false;
  constructor(
    public dialog: MatDialog,
    private hanhchanhService: HanhChanhService,
    private changeDetect: ChangeDetectorRef,
    private layoutUtilsService: LayoutUtilsService,
  ) {
      let user = JSON.parse(localStorage.getItem("UserInfo"));
			this.LIST_ROLES_USER = user.roles;
  }

  ngOnInit() {
    this.SHOW_BUTTON_APPROVE.next(this.isTrueButton(this.DUYET));
    this.selectedRoom.Id_Phong = 0;
    this.getDsPhongHop();
    this.getConfigCalendar();
    //config fullcalendar

  }
  checkExistBooking(data) {
    const _DatPhongHop = new DatPhongHopModel();
    _DatPhongHop.clear();
    _DatPhongHop.NgayDatPhong = data.NgayDatPhong;
    _DatPhongHop.TuGio = data.TuGio;
    _DatPhongHop.DenGio = data.DenGio;
    _DatPhongHop.Id_Phong = this.selectedRoom.Id_Phong;
    this.hanhchanhService.checkExistBooking(_DatPhongHop).subscribe(res => {
      // console.log("res", res);
      if (res && res.status == 1) {
        this.SHOW_BUTTON_BOOKING = true;
      }
      else {
        this.SHOW_BUTTON_BOOKING = false;
        this.layoutUtilsService.showActionNotification(res.error.message, MessageType.Update, 20000, true, false);
      }
    });
  }
  getConfigCalendar() {
    this.option = {
      timeZone: 'local',
      defaultView: "timeGridWeek",
      eventLimit: true,
      header: {
        left: 'selectRoom, selectStatus',
        center: 'prev,title,next',
        right: ''
      },
      themeSystem:'bootstrap',
      buttonIcons:{
        prev: ' flaticon2-fast-back ',
        next: ' flaticon2-fast-next'
      },
      minTime: "06:00",
      maxTime: "19:00",
      slotDuration: "01:00",
      editable: true,
      height: "auto",
      selectable: true,
      selectMirror: true,
      displayEventTime: false,
      firstDay: 1,
      customButtons:{
        selectRoom:{
          text:"Chọn phòng",
          click:function() {
            alert('Chọn phòng!');
          }
        },
        selectStatus:{
          text:"Chọn tình trạng",
          click:function() {
            alert('Chọn tình trạng!');
          }
        }
      },
      eventTimeFormat:{
        hour: '2-digit',
        hour12: false
      },
      columnHeaderHtml: (date) => {
        let _date = new Date(date);
        let str_day = "";
        if (_date.getDay() == 0) {
          str_day = "Chủ nhật";
        }
        else {
          str_day = "Thứ " + (_date.getDay() + 1);
        }
        return "" + _date.getDate() + " - " + str_day;
      },
      selectAllow: (el) => {
        let now = new Date();
        if (el.start > now) {
          const diffTime = Math.abs(el.end - el.start);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          if(diffDays>1){
            return false;
          }
          return true;
        }
        return false;
      },
      allDaySlot: false,
      slotLabelFormat: [
        {
          hour: 'numeric',
          minute: '2-digit',
          hour12: false
        }
      ],
      eventOverlap:(arg)=>{
        return false;
      },
      selectOverlap:(arg)=>{
        return false;
      },
      eventSources: [{
        events: (info, successCallback, failureCallback) => {
          
          let date = {
            start: this.getStrDate(info.start),
            end: this.getStrDate(info.end),
          }
          //week text
          // if(info){
          //   if(info.start.getFullYear()==info.end.getFullYear()){
          //     this.weekText= info.start.getDate()+"/"+(info.start.getMonth() + 1) + " - "+(info.end.getDate()-1)+"/"+(info.start.getMonth() + 1)+", "+info.start.getFullYear();
          //   }
          //   else{
          //     this.weekText= info.start.getDate()+"/"+(info.start.getMonth() + 1)+"/"+info.end.getFullYear() + " - "+(info.end.getDate()-1)+"/"+(info.start.getMonth() + 1)+"/"+info.end.getFullYear();
          //   }
          // }
          //
          this.hanhchanhService.getDatPhong(date.start, date.end, this.selectedRoom.Id_Phong, this.selectedStatus).subscribe(res => {
            this.lstEvent = [];
            // console.log("res", res.data);
            if (res.status == 1 && res.data) {
              this.lstEvent = res.data.map(x => {
                let bgColor = "#e6f6ff";//chờ xác nhận
                let textColor = "#141414";
                if (x.TinhTrang && x.TinhTrang == 1) {
                  bgColor = "#e4e4e4";// đã xác nhận
                }
                return {
                  Id_DP: x.Id_DP,
                  Id_Phong: x.Id_Phong,
                  LyDoHuy: x.LyDoHuy,
                  LyDoKhongXacNhan: x.LyDoKhongXacNhan,
                  NoiDungHop: x.NoiDungHop,
                  TinhTrang: x.TinhTrang,
                  start: x.NgayDatPhong + 'T' + x.TuGio,
                  end: x.NgayDatPhong + 'T' + x.DenGio,
                  title: x.TenNguoiDangKy+"\n" + x.NoiDungHop,
                  editable: true,
                  color: bgColor,
                  textColor: textColor
                }
              });
            }
            // else {
            //   const message = 'Lấy dữ liệu đặt phòng họp thất bại';
            //   this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
            // }
            successCallback(this.lstEvent);
            this.changeDetect.detectChanges();
          });
        }
      }]
    }
  }
  getDsPhongHop() {
    this.hanhchanhService.getPhongHop().subscribe(res => {
      if (res.status == 1 && res.data) {
        // console.log("ds room", res.data);
        this.lstPhong = res.data;
        this.selectedRoom = res.data[0];
        //check dữ liệu truyền vào
        if (this.data) {
          this.data.subscribe(ev => {
            if(ev){
              this._data = ev;
              let date = new Date(ev.NgayDatPhong);
              this.textTime=date.getDate()+"/"+(date.getMonth()+1)+"/"+date.getFullYear() +" "+ev.TuGio+" - "+ev.DenGio;
              // console.log("date", date);
              this.checkExistBooking(ev)
              // console.log("SHOW_BUTTON_BOOKING", this.SHOW_BUTTON_BOOKING);
            }
          })
        }
        //
        this.changeDetect.detectChanges();
        this.calendar.getApi().refetchEvents();
      }
    });
  }

  // handleDateClick(calDate) {
  //   console.log("date click", calDate);
  // }

  eventClicked(el) {
    // console.log("event click", el);
    let DatPhongHop = this.prepareData(el);
    const dialogRef = this.dialog.open(DatPhongHopEditComponent, { data: { DatPhongHop } });
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.calendar.getApi().refetchEvents();
    });
  }
  handleSelect(el) {
    // console.log("select", el);
    let DatPhongHop = new DatPhongHopModel();
    DatPhongHop.clear();
    DatPhongHop.NgayDatPhong = this.getStrDate(el.start);
    DatPhongHop.TuGio = this.getStrTime(el.start);
    DatPhongHop.DenGio = this.getStrTime(el.end);
    DatPhongHop.Id_Phong = Number(this.selectedRoom.Id_Phong);
    DatPhongHop.TenPhong = this.selectedRoom.TenPhong;
    const dialogRef = this.dialog.open(DatPhongHopEditComponent, { data: { DatPhongHop } });
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      //output data id booking
      this.BookingValue.emit(res);
      this.calendar.getApi().refetchEvents();
    });
  }

  // selectOverlap(el) {
  //   return false;
  // }
  // eventOverlap(el) {
  //   return false;
  // }
  eventDrop(el) {
    let data = this.prepareData(el);
    this.UpdateBooking(data);
  }
  eventResize(el) {
    let data = this.prepareData(el);
    this.UpdateBooking(data);
  }
  UpdateBooking(data) {
    this.hanhchanhService.updateDatPhongHop(data).subscribe(res => {
      this.calendar.getApi().refetchEvents();
    });
  }
  prepareData(el) {
    let data = new DatPhongHopModel();
    data.Id_DP = el.event.extendedProps.Id_DP;
    data.Id_Phong = el.event.extendedProps.Id_Phong;
    data.LyDoHuy = el.event.extendedProps.LyDoHuy;
    data.LyDoKhongXacNhan = el.event.extendedProps.LyDoKhongXacNhan;
    data.NoiDungHop = el.event.extendedProps.NoiDungHop;
    data.TinhTrang = el.event.extendedProps.TinhTrang;
    data.NgayDatPhong = this.getStrDate(el.event.start);
    data.TuGio = this.getStrTime(el.event.start);
    data.DenGio = this.getStrTime(el.event.end);
    return data;
  }
  changeRoom(event) {
    if(this.data){
      this.checkExistBooking(this._data);
    }
    this.calendar.getApi().refetchEvents();
  }
  changeStatus(event) {
    this.calendar.getApi().refetchEvents();
  }
  NextWeek(event) {
    this.calendar.getApi().next();
    // this.calendar.getApi().refetchEvents();
  }
  PrevWeek(event) {
    this.calendar.getApi().prev();
    // this.calendar.getApi().refetchEvents();
  }
  getStrDate(date: Date) {
    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
  }
  getStrTime(date: Date) {
    let str = "";
    if (date.getHours() < 10) {
      str += "0" + date.getHours() + ":";
    }
    else {
      str += date.getHours() + ":";
    }
    if (date.getMinutes() < 10) {
      str += "0" + date.getMinutes() + ":";
    }
    else {
      str += date.getMinutes() + ":";
    }
    if (date.getSeconds() < 10) {
      str += "0" + date.getSeconds();
    }
    else {
      str += date.getSeconds();
    }
    return str;
  }
  isTrueButton(ROLENUMBER: number) {
    if (this.LIST_ROLES_USER.findIndex(x => x == ROLENUMBER) > -1) {
      this._title = "Quản lý phòng họp";
      return true;
    }
    this._title = "Đăng ký phòng họp";
    return false;
  }
  Close() {
    window.history.back();
  }
  AddPhongHop() {
    const PhongHop = new PhongHopModel();
    PhongHop.clear();
    const dialogRef = this.dialog.open(PhongHopEditComponent, { data: { PhongHop } });
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.getDsPhongHop();
      this.calendar.getApi().refetchEvents();
    });
  }
  BookingRoom() {
    let DatPhongHop = new DatPhongHopModel();
    DatPhongHop.clear();
    DatPhongHop.NgayDatPhong = this._data.NgayDatPhong;
    DatPhongHop.TuGio = this._data.TuGio;
    DatPhongHop.DenGio = this._data.DenGio;
    DatPhongHop.Id_Phong = Number(this.selectedRoom.Id_Phong);
    DatPhongHop.TenPhong = this.selectedRoom.TenPhong;
    const dialogRef = this.dialog.open(DatPhongHopEditComponent, { data: { DatPhongHop } });
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.calendar.getApi().refetchEvents();
      //output data id booking
      this.BookingValue.emit(res);
    });
  }
  eventRender(event){
    event.el.title=event.event.title;
  }
}
